import React from "react";
import { Text, Em } from "@radix-ui/themes";
import { AgentJoinedMessage } from "../../entities/Message";

export function AgentJoinedMessageComponent({
  text,
  data: { agentDisplayName },
}: AgentJoinedMessage) {
  return (
    <Text
      size={"2"}
      color={"gray"}
      style={{
        padding: "2px 8px",
      }}
    >
      <Em>
        {agentDisplayName != null
          ? `${agentDisplayName} has joined the chat`
          : text}
      </Em>
    </Text>
  );
}
